import axios from 'axios';

export function updateOrganizationPayment(rootApi, organizationId, data) {
  return new Promise((resolve, reject) => {
    const url = `${rootApi}/v1/admin/organizations/${organizationId}/paymentToken`;
    axios(url, {
      method: 'post',
      data,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function(response) {
        localStorage.setItem('paymentPlanKey', response.data.id);
        return resolve(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  });
}

export function getStripeKey(rootApi, organizationId) {
  return new Promise((resolve, reject) => {
    const url = `${rootApi}/v1/admin/organizations/${organizationId}/paymentToken`;
    axios(url, {
      method: 'get',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function(response) {
        return resolve(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/client/modules/user/helpers.js